/**
 * Kit K1 — export menu (CSV/PDF) for the entries view.
 *
 * An "Export" button opens a popover with both options. The data plumbing
 * (reading the displayed entries local-first → dataset → CSV/PDF) lives in
 * the parent (`onExport`); this is only the UI trigger, replicating the
 * canonical `ExportMenu`.
 */
import { Popover } from "@kobalte/core/popover";
import { msg } from "@lingui/core/macro";
import { Download } from "@fleet/icons";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/providers/i18n-provider";

export function EntryExportMenu(props: { onExport: (format: "csv" | "pdf") => void }) {
  const { t } = useI18n();
  return (
    <Popover>
      <Popover.Trigger
        as={Button}
        variant="outline"
        size="sm"
        class="h-8 gap-1.5 rounded-lg text-xs"
        data-testid="entry-export-trigger"
      >
        <Download class="h-3.5 w-3.5" />
        {t(msg`Export`)}
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content class="z-50 w-44 rounded-xl border border-border/60 bg-popover p-2 text-popover-foreground shadow-lg outline-none">
          <div class="flex flex-col gap-1">
            <Button
              variant="ghost"
              size="sm"
              class="h-8 justify-start text-xs"
              data-testid="entry-export-csv"
              onClick={() => props.onExport("csv")}
            >
              {t(msg`Export CSV`)}
            </Button>
            <Button
              variant="ghost"
              size="sm"
              class="h-8 justify-start text-xs"
              data-testid="entry-export-pdf"
              onClick={() => props.onExport("pdf")}
            >
              {t(msg`Export PDF`)}
            </Button>
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover>
  );
}
